import { Offer } from '../types';

export const offers: Offer[] = [
  {
    id: '1',
    title: 'Free Shipping',
    description: 'Free shipping on orders above ₹999',
    discount: 0,
    type: 'fixed',
    minOrderAmount: 999,
    validUntil: '2025-12-31T23:59:59Z',
    isActive: true,
  },
  {
    id: '2',
    title: 'New User Discount',
    description: 'Get 15% off on your first order',
    discount: 15,
    type: 'percentage',
    minOrderAmount: 500,
    validUntil: '2025-12-31T23:59:59Z',
    isActive: true,
  },
  {
    id: '3',
    title: 'Weekend Special',
    description: 'Extra 10% off on weekends',
    discount: 10,
    type: 'percentage',
    validUntil: '2025-12-31T23:59:59Z',
    isActive: true,
  },
  {
    id: '4',
    title: 'Bulk Order Discount',
    description: 'Get 20% off on orders above ₹5000',
    discount: 20,
    type: 'percentage',
    minOrderAmount: 5000,
    validUntil: '2025-12-31T23:59:59Z',
    isActive: true,
  },
];

export const getActiveOffers = (): Offer[] => {
  const now = new Date();
  return offers.filter(offer => 
    offer.isActive && new Date(offer.validUntil) > now
  );
};

export const getOfferByCode = (code: string): Offer | undefined => {
  return offers.find(offer => 
    offer.title.toLowerCase().replace(/\s+/g, '') === code.toLowerCase()
  );
};
